import { Dialog, DialogContent, IconButton, MenuItem, TextField, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import DateTimePickerCustomTime from "components/DateTimePickerCustomTime"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { jobOrderColNm } from "constants/jobOrderConstant"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { AddCircleRounded, RemoveCircleRounded } from "resource/muiImport"
import { generateMenuComboItem } from "utils"

const initJobOrder = {
  AptTm: null,
  ContSize: "20",
  ContTyp: "GP",
  ContHq: 0,
  TlrTypId: 1,
  NumJobOrd: 1,
}

const ContainerVolDialog = ({ dialogOpen, setDialogOpen, initJobOrderData, onFinish, mode }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const [jobOrders, setJobOrders] = useState([])

  const numJobOrd = useMemo(() => jobOrders.reduce((prev, cur) => prev + +cur.NumJobOrd, 0), [jobOrders])

  const dateTimePickerProp = useCallback((name, item, index) => ({
    label: jobOrderColNm[name],
    inputFormat: "DD/MM/YYYY HH:mm",
    mask: "__/__/____ __:__",
    value: item[name],
    onChange: (newValue) => {
      setJobOrders(o => {
        const newJobOrders = [...o]
        newJobOrders[index][name] = newValue
        return newJobOrders
      })
    },
    renderInput: (params) => <TextField size="small" {...params} />,
  }), [])

  const jobOrderProps = useCallback((width, name, item, index) => ({
    size: "small",
    label: jobOrderColNm[name],
    value: item[name],
    sx: { width: width },
    disabled: item.ShpmId ? true : false,
    onChange: (e) => {
      setJobOrders(o => {
        const newJobOrders = [...o]
        newJobOrders[index][name] = e.target.value
        return newJobOrders
      })
    }
  }), [])

  const handleRemoveJobOrderRow = useCallback((index) => {
    setJobOrders(o => {
      const newJobOrders = [...o.JobOrders]
      newJobOrders.splice(index, 1)
      return newJobOrders
    })
  }, [])

  const handleAddJobOrder = useCallback(() => {
    setJobOrders(o => ([
      ...o,
      { ...initJobOrder }
    ]))
  }, [])

  const handleDialogOk = useCallback(() => {
    onFinish(jobOrders)
    setDialogOpen(false)
  }, [jobOrders, onFinish, setDialogOpen])

  useEffect(() => {
    if (dialogOpen) {
      if (initJobOrderData) {
        setJobOrders(initJobOrderData)
      }
    }
  }, [dialogOpen, ax, initJobOrderData])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='sm'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="ข้อมูลตู้"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} height={200} >
          <BoxFR sx={{ zIndex: 1000, height: 40 }}>
            <Typography fontWeight="bold" >ใบงาน ({numJobOrd})</Typography>
            <IconButton sx={{ p: 0 }} onClick={handleAddJobOrder}>
              <AddCircleRounded color="primary" />
            </IconButton>
          </BoxFR>
          {
            jobOrders.map((item, index) => (
              <BoxFR key={index}>
                {/* <Typography width={20}>{index + 1}.</Typography> */}
                <TextField {...jobOrderProps(70, "NumJobOrd", item, index)} label="จำนวน" type="number"
                  inputProps={{ style: { textAlign: "center" } }} />
                <TextField select {...jobOrderProps(80, "ContSize", item, index)} >{generateMenuComboItem(msData.contSizeCombo)}</TextField>
                <TextField select {...jobOrderProps(80, "ContTyp", item, index)}  >{generateMenuComboItem(msData.contTypCombo)}</TextField>
                <TextField select {...jobOrderProps(80, "ContHq", item, index)} >
                  <MenuItem value={0}>Std</MenuItem>
                  <MenuItem value={1}>HQ</MenuItem>
                </TextField>
                {
                  mode === "IM" ?
                    <TextField {...jobOrderProps(120, "FullWt", item, index)} label={jobOrderColNm.FullWt} />
                    :
                    <DateTimePickerCustomTime {...dateTimePickerProp("AptTm", item, index)} />
                }
                {item.ShpmId ? null :
                  <IconButton p={0} onClick={() => handleRemoveJobOrderRow(index)}>
                    <RemoveCircleRounded />
                  </IconButton>
                }
              </BoxFR>
            ))
          }
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={"บันทึก"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(ContainerVolDialog)